import classNames from "classnames";

type PageHeadingProps = {
  text: string;
  className?: string;
};

const PageHeading = (props: PageHeadingProps) => {
  return (
    <h1
      className={classNames("font-bold text-4xl md:text-5xl", props.className)}
    >
      {props.text}
    </h1>
  );
};

export default PageHeading;
